export const common = {
  siteName: '免费韩漫大全',
  siteTitle: '免费韩漫大全 - 韩国漫画在线阅读平台',
  siteDescription: '免费韩漫大全涵盖热血、恋爱、奇幻等全品类韩漫，无需注册即可在线阅读，每日更新最新章节。',
};